'use client';

import { Box } from '@terra/ui-styled-system';
import { IconButton, Tooltip } from '@terra/ui-design-system';
import { type TerraIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';

type CollapsedPanelStripProps = {
  position: 'left' | 'right';
  title: string;
  icon: TerraIcon;
  onClick: () => void;
  hasActivity?: boolean;
};

export function CollapsedPanelStrip({
  position,
  title,
  icon: Icon,
  onClick,
  hasActivity,
}: CollapsedPanelStripProps) {
  const t = useTranslations('layout');
  const showAriaLabel = t('showPanel');

  return (
    <Box
      h="full"
      w="full"
      bg="bg.canvas"
      borderRightWidth={position === 'left' ? '1px' : '0'}
      borderLeftWidth={position === 'right' ? '1px' : '0'}
      borderColor="border.subtle"
      borderRadius="0"
      display="flex"
      flexDirection="column"
      alignItems="center"
      py="2"
      gap="2"
    >
      <Tooltip
        title={title}
        positioning={{ placement: position === 'left' ? 'right' : 'left' }}
      >
        <IconButton
          variant="link"
          size="xs"
          onClick={onClick}
          aria-label={showAriaLabel}
          color="fg.muted"
          _hover={{
            color: 'fg.default',
            bg: 'transparent',
          }}
          minW="auto"
          h="auto"
          p="1"
        >
          <Box position="relative" display="inline-flex">
            <Icon size={12} />
            {hasActivity ? (
              <Box
                position="absolute"
                top="-1px"
                right="-1px"
                w="5px"
                h="5px"
                borderRadius="full"
                bg="colorPalette.default"
                pointerEvents="none"
              />
            ) : null}
          </Box>
        </IconButton>
      </Tooltip>
    </Box>
  );
}
